const bidderCommandItems = (app, user, store, t) => {
  const { cmdBar, integrations = {} } = store;
  const { features } = app;

  const inviteOptions = [
    features.bulkRegistrationPropUp &&
      user.claims &&
      user.claims.idp &&
      user.claims.idp === 'propup'
      ? {
        key: 'bulkregistrationpropup',
        name: t('Import registrations from PropUp'),
        iconProps: {
          iconName: 'PeopleRepeat',
        },
        disabled: !cmdBar.userRegistrationEnabled,
        onClick: () => store.ui.bulkRegistrationPropUp(),
      }
      : null,

    features.bulkRegistrationOnOffice
      ? {
        key: 'bulkregistrationonoffice',
        name: t('Import registrations from OnOffice'),
        iconProps: {
          iconName: 'PeopleRepeat',
        },
        disabled: !cmdBar.userRegistrationEnabled,
        onClick: () => store.ui.bulkRegistrationOnOffice(),
      }
      : null,

    features.bulkRegistrationPropstack
      ? {
        key: 'bulkregistrationpropstack',
        name: t('Import registrations from Propstack'),
        iconProps: {
          iconName: 'PeopleRepeat',
        },
        disabled: !cmdBar.userRegistrationEnabled,
        onClick: () => store.ui.bulkRegistrationPropstack(),
      }
      : null,

    features.bulkRegistrationCrm || !!(integrations && integrations.justimmo)
      ? {
        key: 'bulkregistrationcrm',
        name: t('Import registrations from CRM'),
        iconProps: {
          iconName: 'PeopleRepeat',
        },
        disabled: !cmdBar.userRegistrationEnabled,
        onClick: () => store.ui.bulkRegistrationCrm(),
      }
      : null,

    features.registrationReadOnly
      ? null
      : {
        key: 'register',
        text: t('Register new user'),
        iconProps: {
          iconName: 'PeopleAdd',
        },
        disabled: !cmdBar.userRegistrationEnabled,
        onClick: () => store.ui.registerUser(),
      },

    features.bulkRegistrationCsv
      ? {
        key: 'bulkregistrationcsv',
        text: t('Import registrations from CSV file'),
        iconProps: {
          iconName: 'AddGroup',
        },
        disabled: !cmdBar.userRegistrationEnabled,
        onClick: () => store.ui.bulkRegistrationCsv(),
      }
      : null,

    features.inviteBuyerAgent
      ? {
        key: 'inviteBuyerAgent',
        name: t('Invite Buyer Agent'),
        iconProps: {
          iconName: 'ChatInviteFriend',
        },
        disabled: !store.cmdBar.inviteBuyerAgentEnabled,
        onClick: () => store.ui.inviteBuyerAgent(),
      }
      : null,
  ].filter(Boolean);

  const items = [];

  if (inviteOptions.length === 1) {
    items.push({ ...inviteOptions[0], text: t('Register') });
  }

  if (inviteOptions.length > 1) {
    items.push({
      key: 'invite',
      name: t('Register'),
      iconProps: {
        iconName: 'PeopleAdd',
      },
      disabled: !cmdBar.userRegistrationEnabled,
      subMenuProps: {
        items: inviteOptions,
      },
    });
  }

  items.push({
    key: 'block',
    name: t('Block user'),
    iconProps: {
      iconName: 'PeopleBlock',
    },
    iconOnly: true,
    disabled: !cmdBar.userBlockingEnabled,
    onClick: () =>
      store.ui.prompt.open({
        title: t('Block user'),
        message: t('Are you sure to block user?'),
        content: 'block',
        action: (data) => {
          store.offers.block(data);
        },
      }),
  });

  if (features.selfRegistration) {
    items.push({
      key: 'registration',
      name: t('registration'),
      disabled: !cmdBar.registrationEnabled,
      subMenuProps: {
        items: [
          {
            key: 'approve',
            name: t('approve-registration'),
            iconProps: {
              iconName: 'accept',
            },
            iconOnly: true,
            onClick: () => store.ui.approveRegistration(), // () => store.offers.approveRegistration(),
          },
          {
            key: 'refuse',
            name: t('refuse-registration'),
            iconProps: {
              iconName: 'cancel',
            },
            iconOnly: true,
            onClick: () => store.offers.refuseRegistration(),
          },
        ],
      },
    });
  }

  return items;
};

export { bidderCommandItems };



// WEBPACK FOOTER //
// ./src/app/containers/Sale/Commands/bidderCommandItems.js